import { render, staticRenderFns } from "./resi-print.vue?vue&type=template&id=6dac77d2&scoped=true"
import script from "./resi-print.vue?vue&type=script&lang=js"
export * from "./resi-print.vue?vue&type=script&lang=js"
import style0 from "./resi-print.vue?vue&type=style&index=0&id=6dac77d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac77d2",
  null
  
)

export default component.exports